import React from "react";
import { Form, Input, Select, InputNumber, Switch } from "antd";
import { IconStar } from "@tabler/icons-react";

const CURRENCY_OPTIONS = [
  { value: "MNT", label: "MNT" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "CNY", label: "CNY" },
  { value: "JPY", label: "JPY" },
];

export default function BasicSection({ issuerOptions, categoryOptions }) {
  return (
    <>
      <Form.Item
        name="issuerId"
        label="Байгууллага"
        rules={[{ required: true, message: "Байгууллага сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Банк сонгох"
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={issuerOptions}
        />
      </Form.Item>

      <Form.Item
        name="type"
        label="Хадгаламжийн төрөл"
        rules={[{ required: true, message: "Төрөл сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Сонгох"
          options={[
            { value: "TERM", label: "Хугацаатай хадгаламж" },
            { value: "DEMAND", label: "Хугацаагүй хадгаламж" },
            { value: "CERTIFICATE", label: "Сертификат" },
          ]}
        />
      </Form.Item>

      <Form.Item
        name="primaryCurrency"
        label="Үндсэн валют"
        rules={[{ required: true, message: "Валют сонгоно уу" }]}
        initialValue="MNT"
      >
        <Select options={CURRENCY_OPTIONS} />
      </Form.Item>

      <Form.Item
        name="name"
        label="Хадгаламжийн нэр"
        rules={[{ required: true, message: "Нэр оруулна уу" }]}
      >
        <Input placeholder="Жишээ: Энгийн хугацаатай хадгаламж" />
      </Form.Item>

      <Form.Item
        label="Тайлбар нэршил"
        name="highlight"
        rules={[{ required: true, message: "Тайлбар нэршил өгнө үү" }]}
      >
        <Input placeholder="2–3 үг (жишээ: Хугацаагаа сонгох боломжтой)" />
      </Form.Item>

      <Form.Item
        name="categoryIds"
        label="Ангилал"
        rules={[{ required: true, message: "Ангилал сонгоно уу" }]}
      >
        <Select
          mode="multiple"
          allowClear
          placeholder="3 сар / 6 сар / 1 жил / сертификат..."
          options={categoryOptions}
        />
      </Form.Item>

      <Form.Item
        label="Үнэлгээ (rating)"
        name="rating"
        rules={[{ required: true, message: "Үнэлгээ өгнө үү" }]}
      >
        <InputNumber
          prefix={<IconStar size={16} color="#e68200ff" />}
          min={0}
          max={5}
          step={0.1}
          placeholder="4.5"
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item name="applyUrl" label="Захиалах холбоос">
        <Input placeholder="https://..." />
      </Form.Item>

      <Form.Item
        name="featured"
        label="Нүүрэнд онцлох"
        valuePropName="checked"
        tooltip="Нүүр хуудасны 'Жишээ бүтээгдэхүүн' хэсэгт харагдана"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </>
  );
}
